import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { CoordinationPage, type CoordinationPageFocus } from '@/features/coordination';

function CalendarCoordinationRoute(): ReactNode {
  const focus = Route.useSearch();
  return <CoordinationPage focus={focus} />;
}

export const Route = createFileRoute('/calendar_/coordination')({
  validateSearch,
  component: CalendarCoordinationRoute,
});

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function validateSearch(raw: Record<string, unknown>): CoordinationPageFocus {
  const out: CoordinationPageFocus = {};
  if (typeof raw.poll === 'string' && UUID_RE.test(raw.poll)) out.poll = raw.poll;
  return out;
}
